import {Drawer, styled} from '@mui/material';

const StyledDrawer = styled(Drawer)`
	& .MuiDrawer-paper {
		width: 100vw;
	}
`;

export {StyledDrawer};
